var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebsite2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 960) scale(1, -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M698.366 613.886h-352.254v-170.621h352.254v170.621zM346.112 406.401v-52.304h352.254l0.002 52.304h-352.256zM735.23 335.665c-0.002-10.179-8.253-18.432-18.432-18.432h-176.126v-49.549h109.509c24.576 0 24.576-36.864 0-36.864h-255.887c-24.576 0-24.576 36.864 0 36.864h109.515v49.549h-176.128c-10.181 0-18.432 8.253-18.432 18.432v296.653c0 10.181 8.251 18.432 18.432 18.432h389.118c10.179 0 18.432-8.251 18.432-18.432v-296.653z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite2);
export default __webpack_public_path__ + "static/media/website2.54c340ce9b9a4e05a994a69cd0f0c0d4.svg";
export { ForwardRef as ReactComponent };